import { type WorkspaceTemplateConfig } from '~/components/Modals/BoardTemplateModal/types';

const getCurrentYear = () => new Date().getFullYear();

export const RETAIL_TEMPLATE: WorkspaceTemplateConfig = {
  id: 'retail',
  title: 'Retail',
  description: 'Organize campaigns and product photos.',
  boards: [
    {
      title: 'Products',
      subBoards: [
        {
          title: 'By Collection',
          subBoards: [
            { title: `Spring ${getCurrentYear()}` },
            { title: `Summer ${getCurrentYear()}` },
            { title: `Fall ${getCurrentYear()}` },
            { title: `Winter ${getCurrentYear()}` },
          ],
        },
        {
          title: 'By Category',
        },
      ],
    },
    {
      title: 'Marketing Assets',
      subBoards: [
        {
          title: 'Campaigns',
          subBoards: [
            {
              title: `Spring ${getCurrentYear()} Launch`,
              subBoards: [{ title: 'Hero Images' }, { title: 'Social Media' }, { title: 'Email' }, { title: 'Video' }],
            },
            {
              title: `Fall ${getCurrentYear()} Launch`,
              subBoards: [{ title: 'Hero Images' }, { title: 'Social Media' }, { title: 'Email' }, { title: 'Video' }],
            },
          ],
        },
        {
          title: 'Email Marketing',
          subBoards: [{ title: 'By Campaign' }],
        },
        {
          title: 'Ads',
          subBoards: [{ title: 'Digital' }, { title: 'Print' }],
        },
      ],
    },
    {
      title: 'Brand Assets',
      subBoards: [
        { title: 'Logos' },
        { title: 'Brand Guidelines' },
        { title: 'Fonts' },
        { title: 'Color Palettes' },
        { title: 'Approved Brand Photography' },
      ],
    },
    {
      title: 'E-commerce & Website',
      subBoards: [
        {
          title: 'Product Images',
          subBoards: [{ title: 'Lifestyle' }, { title: 'Studio' }, { title: 'Details' }],
        },
        {
          title: 'Videos',
          subBoards: [{ title: 'Product Demos' }, { title: 'How-to Style' }],
        },
        { title: 'Website Banners' },
        { title: 'Size Charts' },
      ],
    },
    {
      title: 'Sales and Partnerships',
      subBoards: [
        {
          title: 'Retailer Assets',
          subBoards: [{ title: 'Product Catalogs' }, { title: 'Brand Sheets' }, { title: 'Sales Decks' }],
        },
        {
          title: 'Partnership Materials',
          subBoards: [{ title: 'Event Photography' }, { title: 'Co-branded Marketing Materials' }],
        },
      ],
    },
    {
      title: 'Design & Development',
      subBoards: [
        {
          title: 'Product Development',
          subBoards: [{ title: 'Mood Boards' }, { title: 'Inspiration' }],
        },
        {
          title: 'Technical Specs',
          subBoards: [{ title: 'Fabric Swatches' }, { title: 'Size Specifications' }, { title: 'Measurements' }],
        },
      ],
    },
    {
      title: 'Corporate Assets',
      subBoards: [
        { title: 'Company Presentations' },
        { title: 'Press Kits' },
        {
          title: 'Internal Comms',
          subBoards: [{ title: 'Newsletters' }, { title: 'Announcements' }],
        },
      ],
    },
  ],
};
